import {
  ExtranetShopProductDto,
  ExtranetShopProductListItemDto,
} from '@pharmac-extranet/extranet-api'
import * as React from 'react'

export const EXTRANET_SHOPPING_CART_STORAGE_KEY = 'enshoppingcart'
export const EXTRANET_SHOPPING_CART_SETTINGS_STORAGE_KEY = 'enshoppingcartcnfg'

export type AddToCartHookState = {
  [productId: string]: Array<number>
}

type ShoppingCartContext = {
  state: AddToCartHookState
  setState: React.Dispatch<React.SetStateAction<AddToCartHookState>>
}

export const ShoppingCartContext = React.createContext<ShoppingCartContext>(
  {} as ShoppingCartContext
)

export const useShoppingCartContext = () => {
  const { state, setState } = React.useContext(ShoppingCartContext)

  const addAndRemoveCartButton = (
    {
      productId,
    }:
      | ExtranetShopProductListItemDto
      | ExtranetShopProductDto
      | ExtranetShopProductListItemDto
      | {
          productId: number
        },
    id: number
  ) => {
    const exists: number[] | false = state[productId] ?? false
    setState((s) => {
      if (!exists) return { ...s, [productId]: [id] }

      return {
        ...s,
        [productId]: exists.includes(id) ? exists.filter((a) => a !== id) : exists.concat(id),
      }
    })
  }

  const [selectedProductList, setSelectedProductList] = React.useState<
    { productId: number; quantity: number }[]
  >([])

  React.useEffect(() => {
    const products = Object.entries(state).map(([key, value]) => {
      if (value !== undefined && Number(value) > 0) {
        return {
          productId: Number(key),
          quantity: 1,
        }
      }
    })
    setSelectedProductList(
      products.filter((a): a is { productId: number; quantity: number } => !!a)
    )
  }, [state])

  return {
    selectedProducts: state,
    selectedProductList,
    setSelectedProducts: setState,
    addAndRemoveCartButton,
  }
}
